export default __webpack_public_path__ + "static/media/user-button.66f12a5a.svg";